














































import Component from 'vue-class-component';
import {Emit, Watch} from 'vue-property-decorator';
import {
    DateRangeMapper,
    GroupBy,
    IDictionary,
    IFormControl,
    IGetTop10StatsModel,
    IListItem,
    SiteAdditionalFilterRule,
    sitesToListItems
} from '@/entities';
import sitesApi from '@/api/sites.api';
import {createPeriodListItems, formatDate} from '@/utils';
import {FormFilterComponent} from '@/components/base/form-filter/form-filter.component';

@Component({})
export default class Top10Criteria extends FormFilterComponent {
    public showAdditionalSite: boolean = false;

    public dateRangeHints: IListItem[] = [
        { heading: 'Choose period', value: null },
        ...createPeriodListItems(50, 27)
    ];

    public formState: IDictionary<IFormControl> = {
        siteId: {
            key: 'siteId',
            label: 'Site',
            value: null
        },
        dateRange: {
            key: 'dateRange',
            label: 'Date',
            value: this.getDefaultDateRange(),
            mapper: DateRangeMapper
        },
        siteIds: {
            key: 'siteIds',
            label: 'Additional Sites',
            value: [],
            mapper: SiteAdditionalFilterRule
        }
    };

    public sitesInProgress: boolean = false;
    public sites: IListItem[] = [];
    public sitesAdditional: IListItem[] = [];

    public async created() {
        this.sitesInProgress = true;
        try {
            const items = await sitesApi.list();
            const mapped = sitesToListItems(items);
            this.sites = [
                { heading: 'All Sites', value: null },
                ...mapped,
                { heading: 'Custom', value: 'Custom' }
            ];
            this.sitesAdditional = [...mapped];

            this.doSearch();
            this.siteChange();
        } finally {
            this.sitesInProgress = false;
        }
    }

    public siteChange() {
        this.showAdditionalSite = this.formState.siteId.value === 'Custom';
    }

    @Emit() public search(body: IGetTop10StatsModel) {
        this.saveDateRange({
            start: body.start,
            end: body.end
        });
    }

    public defaultFormValues(): IDictionary<any> {
        return {
            siteId: null,
            dateRange: this.getDefaultDateRange(),
            siteIds: []
        };
    }

    public getQueryObject(formState: IDictionary<IFormControl>) {
        let siteIds = this.formState.siteId.value
            ? [formState.siteId.value]
            : [];
        if (formState.siteId.value === 'Custom') {
            siteIds = formState.siteIds.value ? formState.siteIds.value : [];
        }
        return {
            start: formatDate(formState.dateRange.value.start),
            end: formatDate(formState.dateRange.value.end),
            groupBy: (this.dateRangeMoreOneWeek) ? GroupBy.Company : GroupBy.Agent,
            siteIds
        };
    }

    private get dateRangeMoreOneWeek(): boolean {
        return (this.formState.dateRange.value.end - this.formState.dateRange.value.start) > (1000 * 60 * 60 * 24 * 7);
    }

    @Watch('$route') private onRouteChanged(val: string, oldVal: string) {
        this.doSearch();
    }
}
